import React, { Component } from 'react';
import IosSwitch from '../IosSwitch';
import DefaultButton from '../DefaultButton';
import DefaultLoader from '../DefaultLoader';
import SessionHelper from '../../helper/SessionHelper';
import ReportHelper from '../../helper/ReportHelper';
import moment from 'moment';
import ReportDefaultModalOptions from './ReportDefaultModalOptions';

export default class StudentListReport extends Component {

    state = {
        name: `Lista de Alunos - ${SessionHelper.getData().company.name}`,
        loadingModal: true,
        paramDoc: {},
        studentDocs: [],
        users: [],
        allUsers: true,
        output: 'download',
        format: 'pdf',
    }

    async componentDidMount() {

        if (this.props.getDocs && this.props.getDocs.length) {

            for (let index = 0; index < this.props.getDocs.length; index++) {
                
                const getDoc = this.props.getDocs[index];
                await getDoc(this);
            }
        }

        this.setState({ loadingModal: false });
    }

    getReportDocs() {

        let users = this.state.allUsers ? this.state.studentDocs : this.state.users;
        let docs = [];

        users.forEach((user, key) => {

            let userDoc = user;

            if (!this.state.allUsers) {

                userDoc = this.state.studentDocs.find(item => item.id === user);
            }

            docs.push(userDoc);
        });

        docs.sort((a, b) => {

            return a.name.toLowerCase() > b.name.toLowerCase();
        });

        return docs;
    }

    async print() {

        this.setState({ loadingModal: true });

        let docs = this.getReportDocs();
        let report = await ReportHelper.createReport(this.state.name);

        report = await ReportHelper.createColumns(report, docs, [
            { name: 'Nome', width: 13, getText: (doc) => doc.name ? ReportHelper.treatName(doc.name) : '' },
            { name: 'Contato', width: 50, getText: (doc) => doc.phone || '' },
            { name: 'Cpf', width: 85, getText: (doc) => doc.cpf ? doc.cpf.toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : '' },
            { name: 'Sexo', width: 115, getText: (doc) => doc.sex === 'M' ? 'Masculino' : doc.sex === 'F' ? 'Feminino' : 'Outro' },
            { name: 'Nascimento', width: 136, getText: (doc) => doc.birth_date ? moment(doc.birth_date.toDate()).format('DD/MM/YYYY') : '' },
            { name: 'Categoria', width: 160, getText: (doc) => this.getStudentCategory(doc.category) },
        ]);

        report = await ReportHelper.createColumns(report, [{ count: docs.length }], [
            { name: 'Total', width: 160, getText: (doc) => doc.count.toString() },
        ], null, false, 6);

        ReportHelper.print(report, this.state.output, this.state.format);

        this.setState({ loadingModal: false });
    }

    getStudentCategory(studentCategory) {

        let result = '';
        let category = this.state.paramDoc.categories.find(item => item.value == studentCategory);

        if (category) {

            result = category.label;
        }

        return result;
    }

    renderLoading() {

        return (

            <div style={{ height: 200 }}>
                <DefaultLoader/>
            </div>
        )
    }

    renderModal() {

        return (

            <div>
                <IosSwitch fullWidth label={'Todos os Alunos'} checked={this.state.allUsers} onChange={(e) => { this.setState({ allUsers: e, users: [] }) }} />
                { !this.state.allUsers ? ReportHelper.renderUserSelection(this, this.state.studentDocs, 'users') : null }
                <ReportDefaultModalOptions onOutputChange={(value) => { this.setState({ output: value }) }} onFormatChange={(value) => { this.setState({ output: value }) }}/>
                <div style={{alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 50}}>
                    <DefaultButton width={'100%'} title={'Imprimir'} onClick={() => { this.print() }} />
                </div>
            </div>
        )
    }

    render() {

        return (

            this.state.loadingModal ? this.renderLoading() : this.renderModal()
        )
    }
}